module.exports = __webpack_public_path__ + "static_pc/img/case2.3ea77270.png";